export const THEME_CLOUD = 'cloud';
export const THEME_MIDNIGHT = 'midnight';
export const THEME_VOLCANO = 'volcano';
export const THEME_AMETHYST = 'amethyst';
export const THEME_CHERRY_BLOSSOM = 'cherry_blossom';
export const THEME_FOREST = 'forest';
export const THEME_WOODLAND = 'woodland';
export const THEME_SUNSET = 'sunset';
export const THEME_TWILIGHT = 'twilight';
export const THEME_OCEAN = 'ocean';

export const THEME_BASIC = 'basic';
export const THEME_LIGHT = 'light';
export const THEME_DARK = 'dark';
export const THEME_LIST = [
  THEME_CLOUD,
  THEME_MIDNIGHT,
  THEME_VOLCANO,
  THEME_AMETHYST,
  THEME_CHERRY_BLOSSOM,
  THEME_FOREST,
  THEME_WOODLAND,
  THEME_SUNSET,
  THEME_TWILIGHT,
  THEME_OCEAN
];
// Theme Faq Page
export const THEME_LIGHT_FAQ_PAGE = 'light-faq-page';
export const THEME_DARK_FAQ_PAGE = 'dark-faq-page';
export const THEME_AVADA_FAQ_PAGE = 'avada-faq-page';

export const THEME_GREEN_FAQ_PAGE = 'green-faq-page';
